// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1C9sZ","location":"Header_location__3iBFL"};